<template>
<crud-layout :title="title" :subtitle="subtitle">

        <template v-slot:list>
            <pedido-cuenta-list 
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"
            
            />
        </template>
        
         <add-button v-if="$store.getters.hasPermission('PEDIDOCUENTA_CREATE')" @click="create"></add-button>
      
        <pedido-cuenta-create v-if="creating" 
                        :open="creating"
                        v-on:itemCreated="onItemCreated" 
                        v-on:close="creating=false" 
        />
        
        <pedido-cuenta-update v-if="updating" 
                        :open="updating"
                        :item="itemToEdit" 
                        v-on:itemUpdated="onItemUpdated" 
                        v-on:close="updating=false" 
        />
          
        <pedido-cuenta-show v-if="showing" 
                           :open="showing" 
                           :item="itemToShow"  
                           v-on:close="showing=false" 
         />

        <pedido-cuenta-delete v-if="deleting" 
                         :open="deleting"
                         :item="itemToDelete"  
                         v-on:itemDeleted="onItemDeleted" 
                         v-on:close="deleting=false" 
        />

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>
    
    import PedidoCuentaCreate from "../PedidoCuentaCreate";
    import PedidoCuentaUpdate from "../PedidoCuentaUpdate";
    import PedidoCuentaDelete from "../PedidoCuentaDelete";
    import PedidoCuentaShow from "../PedidoCuentaShow";
    import PedidoCuentaList from "../PedidoCuentaList";
    
     import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"
     
    export default {
        name: "PedidoCuentaCrud",
        components: {
            CrudLayout, AddButton, Snackbar,
            PedidoCuentaCreate, 
            PedidoCuentaUpdate, 
            PedidoCuentaDelete, 
            PedidoCuentaShow,
            PedidoCuentaList
        },
        data() {
            return {
                title: 'cobrox.pedidoCuenta.title',
                subtitle: 'cobrox.pedidoCuenta.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }
        
    }
</script>


